import React, { useMemo, type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { getCloudId } from '@helpcenter/meta';
import { EnvType, getEnv } from '@atlassian/help-center-common-util/env';
import { PostOfficeProvider } from '@atlassian/post-office-context/post-office';
import type { Env } from '@atlassian/post-office-context/post-office/types';

const POST_OFFICE_ENV: Record<EnvType, Env> = {
	[EnvType.LOCAL]: 'local',
	[EnvType.DEV]: 'dev',
	[EnvType.STAGING]: 'staging',
	[EnvType.PROD]: 'production',
};

/**
 * Help Center mounts no `PostOfficeProvider`, so without this the placement request would carry no
 * product, tenant or locale. `jira` / `service_desk` is the pair the Jira SPA sends for JSM, which
 * Post Office maps to `jira-servicedesk`.
 */
export const PostOfficeScope = ({ children }: { children: ReactNode }) => {
	const { locale } = useIntl();

	const environment = useMemo(() => ({ env: POST_OFFICE_ENV[getEnv().environment] }), []);
	const context = useMemo(
		() => ({
			current: {
				locale,
				product: 'jira',
				subproduct: 'service_desk',
				tenantId: getCloudId(),
			},
		}),
		[locale],
	);

	return (
		<PostOfficeProvider context={context} environment={environment}>
			{children}
		</PostOfficeProvider>
	);
};
